/* Steady Freddy — Enhanced ED Quiz (Australia)
   Reordered flow with interstitials, no US states, no HIPAA.
*/
(function () {
  "use strict";

  var ASSETS = window.SF_ED_QUIZ_ASSETS || {};

  var STEPS = [
    // ══════ SECTION 1: Problem-Oriented Questions ══════
    { id: "experiencing_ed", kind: "radio", visual: "coupleProduct", kicker: "Your symptoms", q: "Are you currently experiencing erectile dysfunction?",
      options: [
        { v: "yes_regular", t: "Yes, regularly", icon: "circle-dot", tone: "orange" },
        { v: "yes_sometimes", t: "Yes, sometimes", icon: "activity", tone: "blue" },
        { v: "yes_recently", t: "Yes, just recently started", icon: "trending-up", tone: "purple" },
        { v: "no", t: "No, I'm here for prevention", icon: "shield-check", tone: "green" }
      ]
    },

    { id: "severity", kind: "radio", visual: "bedroom", kicker: "Your symptoms", q: "How would you describe the severity?",
      options: [
        { v: "mild", t: "Mild", d: "Occasional difficulty achieving or maintaining", icon: "circle-dot", tone: "green" },
        { v: "moderate", t: "Moderate", d: "Frequent difficulty, but sometimes successful", icon: "activity", tone: "purple" },
        { v: "severe", t: "Severe", d: "Consistent difficulty most times", icon: "alert-circle", tone: "orange" }
      ]
    },

    // ══════ INTERSTITIAL: ED Education ══════
    { kind: "interstitial", visual: "stat", kicker: "Did you know?", q: "ED is more common than you think",
      help: "Over 50% of Australian men experience erectile dysfunction at some point in their lives. It's not just about age — stress, lifestyle, and health conditions all play a role. The good news? Modern treatments are highly effective, discreet, and accessible." },

    { id: "duration", kind: "radio", visual: "timeline", kicker: "Understanding your situation", q: "How long have you been experiencing symptoms?",
      options: [
        { v: "<1mo", t: "Less than 1 month", icon: "calendar-days", tone: "green" },
        { v: "1-3mo", t: "1–3 months", icon: "calendar-days", tone: "blue" },
        { v: "3-6mo", t: "3–6 months", icon: "calendar-days", tone: "purple" },
        { v: "6-12mo", t: "6–12 months", icon: "calendar-days", tone: "orange" },
        { v: ">12mo", t: "More than a year", icon: "calendar-days", tone: "orange" }
      ]
    },

    { id: "impact", kind: "radio", visual: "bedroom", kicker: "Understanding your situation", q: "How has this affected your quality of life?",
      options: [
        { v: "minimal", t: "Minimal impact", d: "Life goes on as normal", icon: "smile", tone: "green" },
        { v: "moderate", t: "Moderate impact", d: "Affects confidence and relationships", icon: "frown", tone: "purple" },
        { v: "significant", t: "Significant impact", d: "Major effect on wellbeing", icon: "alert-circle", tone: "orange" }
      ]
    },

    { id: "triggers", kind: "checkbox", visual: "product", kicker: "Understanding your situation", q: "Do any of these apply to you?",
      help: "Select all that apply.",
      options: [
        { v: "stress", t: "High stress or anxiety", icon: "brain", tone: "orange" },
        { v: "sleep", t: "Poor sleep quality", icon: "moon", tone: "blue" },
        { v: "exercise", t: "Low physical activity", icon: "activity", tone: "purple" },
        { v: "diet", t: "Unhealthy diet", icon: "utensils", tone: "orange" },
        { v: "none", t: "None of the above", icon: "check", tone: "green", exclusive: true }
      ]
    },

    { id: "previous_treatment", kind: "radio", visual: "product", kicker: "Your history", q: "Have you tried ED treatment before?",
      options: [
        { v: "yes_worked", t: "Yes, and it worked well", icon: "thumbs-up", tone: "green" },
        { v: "yes_partial", t: "Yes, with mixed results", icon: "rotate-ccw", tone: "blue" },
        { v: "yes_no_effect", t: "Yes, but didn't work", icon: "x-circle", tone: "purple" },
        { v: "yes_sides", t: "Yes, but had side effects", icon: "triangle-alert", tone: "orange" },
        { v: "never", t: "No, never tried treatment", icon: "sparkles", tone: "purple" }
      ]
    },

    { id: "previous_type", kind: "checkbox", visual: "product", kicker: "Your history", q: "Which treatments have you tried? (if any)",
      help: "Select all that apply.",
      options: [
        { v: "sildenafil", t: "Sildenafil (Viagra)", icon: "pill", tone: "blue" },
        { v: "tadalafil", t: "Tadalafil (Cialis)", icon: "pill", tone: "orange" },
        { v: "other_pills", t: "Other oral medication", icon: "capsule", tone: "purple" },
        { v: "natural", t: "Natural supplements", icon: "leaf", tone: "green" },
        { v: "therapy", t: "Counselling or therapy", icon: "user-check", tone: "blue" },
        { v: "none", t: "None", icon: "check", tone: "green", exclusive: true }
      ]
    },

    // ══════ TESTIMONIAL ══════
    { kind: "testimonial", visual: "testimonial", kicker: "Verified outcome", q: "I was hesitant at first, but the whole process was so easy and professional. Noticed real improvements within weeks!",
      help: "— James, 45 • Sydney" },

    { id: "goal", kind: "radio", visual: "bedroom", kicker: "Your goals", q: "What's most important to you in treatment?",
      options: [
        { v: "fast", t: "Fast-acting results", d: "Works quickly when you need it", icon: "zap", tone: "orange" },
        { v: "long", t: "Long-lasting effects", d: "Lasts 24–36 hours", icon: "clock", tone: "blue" },
        { v: "spontaneous", t: "Spontaneity", d: "Don't want to plan ahead", icon: "sparkles", tone: "purple" },
        { v: "minimal_sides", t: "Fewest side effects", icon: "shield-check", tone: "green" }
      ]
    },

    { id: "frequency", kind: "radio", visual: "product", kicker: "Your goals", q: "How often do you anticipate needing treatment?",
      options: [
        { v: "regular", t: "Regularly (2+ times per week)", icon: "calendar-check", tone: "orange" },
        { v: "weekly", t: "Weekly", icon: "calendar-days", tone: "blue" },
        { v: "occasionally", t: "Occasionally (few times a month)", icon: "calendar", tone: "purple" },
        { v: "rarely", t: "Rarely (as needed)", icon: "calendar-clock", tone: "green" }
      ]
    },

    { id: "format_preference", kind: "radio", visual: "product", kicker: "Your goals", q: "What treatment format appeals to you?",
      options: [
        { v: "daily", t: "Daily low-dose pill", d: "Always ready, no planning", icon: "pill", tone: "blue" },
        { v: "on_demand", t: "On-demand pill", d: "Take before activity", icon: "timer", tone: "orange" },
        { v: "flexible", t: "Flexible (I'm open to advice)", icon: "lightbulb", tone: "purple" }
      ]
    },

    { id: "lifestyle", kind: "checkbox", visual: "bedroom", kicker: "Lifestyle factors", q: "Do any of these apply to your lifestyle?",
      help: "This helps us provide personalized advice. Select all that apply.",
      options: [
        { v: "smoker", t: "I smoke tobacco", icon: "cigarette", tone: "orange" },
        { v: "alcohol", t: "I drink alcohol regularly", icon: "wine", tone: "purple" },
        { v: "exercise", t: "I exercise regularly", icon: "dumbbell", tone: "green" },
        { v: "healthy_diet", t: "I eat a balanced diet", icon: "apple", tone: "green" },
        { v: "none", t: "None of the above", icon: "check", tone: "blue", exclusive: true }
      ]
    },

    // ══════ HOW IT WORKS ══════
    { kind: "how_it_works", visual: "timeline", kicker: "How Steady Freddy works", q: "Simple, private, effective",
      help: "1. Complete assessment (5 min) → 2. Australian doctor reviews your case → 3. Discreet delivery to your door" },

    // ══════ SECTION 2: Medical Disqualification ══════
    { id: "current_medications", kind: "checkbox", visual: "doctor", kicker: "Medical screening", q: "Are you currently taking any of these medications?",
      help: "This helps us ensure your safety. Select all that apply.",
      options: [
        { v: "nitrates", t: "Nitrates", d: "For chest pain or angina", icon: "heart-pulse", tone: "orange" },
        { v: "alpha_blockers", t: "Alpha-blockers", d: "For blood pressure or prostate", icon: "activity", tone: "blue" },
        { v: "blood_thinners", t: "Blood thinners", d: "Warfarin, aspirin, etc.", icon: "droplet", tone: "purple" },
        { v: "bp_meds", t: "Blood pressure medication", icon: "heart", tone: "orange" },
        { v: "none", t: "None of the above", icon: "check", tone: "green", exclusive: true }
      ]
    },

    { id: "health_conditions", kind: "checkbox", visual: "doctor", kicker: "Medical screening", q: "Do you have any of these health conditions?",
      help: "Select all that apply.",
      options: [
        { v: "heart", t: "Heart disease or recent heart attack", icon: "heart-pulse", tone: "orange" },
        { v: "stroke", t: "Recent stroke", icon: "brain", tone: "orange" },
        { v: "bp_high", t: "Uncontrolled high blood pressure", icon: "trending-up", tone: "orange" },
        { v: "bp_low", t: "Low blood pressure", icon: "trending-down", tone: "purple" },
        { v: "diabetes", t: "Diabetes", icon: "circle-alert", tone: "purple" },
        { v: "kidney", t: "Kidney disease", icon: "shield-alert", tone: "orange" },
        { v: "liver", t: "Liver disease", icon: "shield-alert", tone: "orange" },
        { v: "none", t: "None of the above", icon: "check", tone: "green", exclusive: true }
      ]
    },

    { id: "allergies", kind: "radio", visual: "doctor", kicker: "Medical screening", q: "Do you have any known allergies to ED medications?",
      options: [
        { v: "yes", t: "Yes", icon: "alert-triangle", tone: "orange" },
        { v: "no", t: "No", icon: "check", tone: "green" },
        { v: "unsure", t: "Not sure", icon: "help-circle", tone: "blue" }
      ]
    },

    // ══════ BENEFITS ══════
    { kind: "benefits", visual: "product", kicker: "Why choose Steady Freddy", q: "TGA-approved medication, Australian doctors, discreet packaging, fast delivery",
      help: "Only genuine Australian-approved treatments reviewed by registered medical professionals." },

    // ══════ SECTION 3: Personal Information ══════
    { id: "age", kind: "number", visual: "doctor", kicker: "Your details", q: "What's your age?",
      placeholder: "Enter your age", help: "You must be 18 or older to use this service.", min: 18, max: 99 },

    { id: "contact_info", kind: "multi_field", visual: "delivery", kicker: "Your details", q: "What's your name and email?",
      help: "We'll send your assessment results here.",
      fields: [
        { id: "name", type: "text", placeholder: "Full name", label: "Full name" },
        { id: "email", type: "email", placeholder: "name@example.com", label: "Email address" }
      ]
    },

    { id: "phone", kind: "tel", visual: "delivery", kicker: "Your details", q: "What's your mobile number?",
      placeholder: "04XX XXX XXX", help: "For SMS updates about your order and delivery." },

    { id: "postcode", kind: "text", visual: "delivery", kicker: "Your details", q: "What's your postcode?",
      placeholder: "e.g. 2000", help: "To confirm we deliver to your area.", pattern: "\\d{4}" },

    { id: "best_contact", kind: "checkbox", visual: "delivery", kicker: "Your details", q: "When's the best time to contact you?",
      help: "Select all that apply.",
      options: [
        { v: "morning", t: "Morning", d: "9am – 12pm", icon: "sun", tone: "orange" },
        { v: "afternoon", t: "Afternoon", d: "12pm – 5pm", icon: "sun-medium", tone: "blue" },
        { v: "evening", t: "Evening", d: "5pm – 8pm", icon: "moon", tone: "purple" },
        { v: "anytime", t: "Anytime is fine", icon: "clock", tone: "green" }
      ]
    },

    // ══════ TESTIMONIAL 2 ══════
    { kind: "testimonial", visual: "testimonial", kicker: "Real results", q: "Game changer! My confidence is back and my relationship has never been better. Wish I'd done this sooner.",
      help: "— Tom, 52 • Melbourne" },

    { id: "privacy_consent", kind: "checkbox", visual: "delivery", kicker: "Privacy & consent", q: "Please confirm to continue:",
      options: [
        { v: "consent", t: "I understand my information is kept private and secure, and I consent to be contacted by Steady Freddy's medical team regarding my assessment.", icon: "check", tone: "green" }
      ]
    }
  ];

  var STORE = "sf_ed_quiz";
  var answers = {};
  try { answers = JSON.parse(localStorage.getItem(STORE)) || {}; } catch (e) { answers = {}; }
  var shell = document.getElementById("quizShell");
  var loading = document.getElementById("quizLoading");
  var fill = document.getElementById("progressFill");
  var counter = document.getElementById("progressCounter");
  var backTop = document.getElementById("progressBack");
  var segments = document.getElementById("progressSegments");
  var index = 0;
  var total = STEPS.length;

  if (!shell) return;

  function save() { try { localStorage.setItem(STORE, JSON.stringify(answers)); } catch (e) {} }
  function esc(s) { return String(s == null ? "" : s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

  function visualHtml(type) {
    // No images - just text-based infographic cards
    if (type === "stat") {
      return '<div class="sf-edq-statcard"><p>ED affects 1 in 2 men</p><strong>50%</strong><em>of Australian men experience ED at some point in their lives</em></div>';
    }
    if (type === "timeline") {
      return '<div class="sf-edq-timeline">' +
        '<div class="sf-edq-timeline__step"><span class="sf-edq-timeline__num">1</span><h4>Complete Assessment</h4><p>5-minute confidential questionnaire</p></div>' +
        '<div class="sf-edq-timeline__step"><span class="sf-edq-timeline__num">2</span><h4>Doctor Review</h4><p>Australian GP reviews your case</p></div>' +
        '<div class="sf-edq-timeline__step"><span class="sf-edq-timeline__num">3</span><h4>Discreet Delivery</h4><p>Fast delivery to your door</p></div>' +
        '</div>';
    }
    if (type === "testimonial") {
      return '<div class="sf-edq-testimonial"><div class="sf-edq-testimonial__stars">★★★★★</div></div>';
    }
    // Return empty string for other visual types (no images)
    return '';
  }

  function buildSegments() {
    if (!segments) return;
    segments.innerHTML = "";
    STEPS.forEach(function (_, i) {
      var seg = document.createElement("span");
      seg.className = "sf-edq-segment";
      seg.setAttribute("aria-hidden", "true");
      segments.appendChild(seg);
    });
  }

  function optionHtml(Q) {
    var html = '<div class="sf-edq-options" role="' + (Q.kind === "radio" ? "radiogroup" : "group") + '" aria-label="' + esc(Q.q) + '">';
    Q.options.forEach(function (o) {
      html += '<div class="sf-edq-option" tabindex="0" role="' + (Q.kind === "radio" ? "radio" : "checkbox") + '" aria-checked="false"' +
        (Q.kind === "checkbox" ? ' data-multi' : '') +
        ' data-val="' + esc(o.v) + '"' + (o.exclusive ? ' data-exclusive' : '') + '>' +
        '<span class="sf-edq-option__icon tone-' + esc(o.tone || "blue") + '"><svg data-lucide="' + esc(o.icon || "circle") + '"></svg></span>' +
        '<span class="sf-edq-option__body"><span class="sf-edq-option__title">' + esc(o.t) + '</span>' +
        (o.d ? '<span class="sf-edq-option__desc">' + esc(o.d) + '</span>' : '') +
        '</span></div>';
    });
    return html + '</div>';
  }

  function fieldHtml(Q) {
    var html = '<div class="sf-edq-field">';
    if (Q.kind === "multi_field" && Q.fields) {
      Q.fields.forEach(function (f) {
        html += '<div class="sf-edq-field-group">';
        if (f.label) html += '<label class="sf-edq-label" for="f-' + f.id + '">' + esc(f.label) + '</label>';
        html += '<input class="sf-edq-input" id="f-' + f.id + '" type="' + esc(f.type) + '" placeholder="' + esc(f.placeholder || "") + '"' +
          (f.type === "tel" ? ' inputmode="tel"' : '') +
          (f.type === "email" ? ' inputmode="email"' : '') + '>';
        html += '</div>';
      });
    } else {
      var type = Q.kind === "number" ? "number" : Q.kind === "date" ? "date" : Q.kind === "email" ? "email" : Q.kind === "tel" ? "tel" : "text";
      html += '<input class="sf-edq-input" id="f-' + Q.id + '" type="' + esc(type) + '" placeholder="' + esc(Q.placeholder || "") + '"' +
        (Q.kind === "number" ? ' inputmode="numeric" min="' + (Q.min || 18) + '" max="' + (Q.max || 99) + '"' : '') +
        (Q.kind === "tel" ? ' inputmode="tel"' : '') +
        (Q.pattern ? ' pattern="' + esc(Q.pattern) + '"' : '') + '>';
    }
    return html + '</div>';
  }

  function buildSteps() {
    STEPS.forEach(function (Q, i) {
      var step = document.createElement("section");
      step.className = "sf-edq-step";
      step.setAttribute("data-step", i);

      // Interstitials
      if (Q.kind === "interstitial" || Q.kind === "testimonial" || Q.kind === "how_it_works" || Q.kind === "benefits") {
        var html = visualHtml(Q.visual);
        html += '<div class="sf-edq-copy">';
        html += '<p class="sf-edq-kicker">' + esc(Q.kicker) + '</p>';
        html += '<h1>' + esc(Q.q) + '</h1>';
        if (Q.help) html += '<p class="sf-edq-help">' + esc(Q.help) + '</p>';
        html += '<button class="sf-edq-next" data-next type="button">Continue <span aria-hidden="true">-&gt;</span></button>';
        html += '</div>';
        step.innerHTML = html;
        step.querySelector("[data-next]").addEventListener("click", next);
        shell.appendChild(step);
        return;
      }

      // Regular questions
      var html = visualHtml(Q.visual);
      html += '<div class="sf-edq-copy">';
      html += '<p class="sf-edq-kicker">' + esc(Q.kicker) + '</p>';
      html += '<h1>' + esc(Q.q) + '</h1>';
      if (Q.help) html += '<p class="sf-edq-help">' + esc(Q.help) + '</p>';
      if (Q.kind === "radio" || Q.kind === "checkbox") html += optionHtml(Q);
      if (["number","text","email","tel","date","multi_field"].indexOf(Q.kind) !== -1) html += fieldHtml(Q);
      html += '<p class="quiz-error" id="err-' + Q.id + '"></p>';
      html += '<button class="sf-edq-next" data-next type="button">' + (i === total - 1 ? "Submit assessment" : "Next") + ' <span aria-hidden="true">-&gt;</span></button>';
      html += '<div class="sf-edq-secure"><svg data-lucide="lock"></svg> Private and secure</div>';
      html += '</div>';
      step.innerHTML = html;
      shell.appendChild(step);

      step.querySelectorAll(".sf-edq-option").forEach(function (opt) {
        function toggle() {
          var val = opt.getAttribute("data-val");
          var shouldAutoAdvance = false;
          if (Q.kind === "radio") {
            step.querySelectorAll(".sf-edq-option").forEach(function (o) { o.classList.remove("is-selected"); o.setAttribute("aria-checked","false"); });
            opt.classList.add("is-selected");
            opt.setAttribute("aria-checked","true");
            answers[Q.id] = val;
            shouldAutoAdvance = true;
          } else {
            if (opt.hasAttribute("data-exclusive")) {
              step.querySelectorAll(".sf-edq-option").forEach(function (o) { o.classList.remove("is-selected"); o.setAttribute("aria-checked","false"); });
              opt.classList.add("is-selected");
              opt.setAttribute("aria-checked","true");
              answers[Q.id] = [val];
              shouldAutoAdvance = true;
            } else {
              step.querySelectorAll(".sf-edq-option[data-exclusive]").forEach(function (o) { o.classList.remove("is-selected"); o.setAttribute("aria-checked","false"); });
              opt.classList.toggle("is-selected");
              opt.setAttribute("aria-checked", opt.classList.contains("is-selected") ? "true" : "false");
              var exclusive = Q.options.filter(function (oo) { return oo.exclusive; }).map(function (oo) { return oo.v; });
              var arr = (answers[Q.id] || []).filter(function (x) { return exclusive.indexOf(x) === -1; });
              var pos = arr.indexOf(val);
              if (pos === -1) arr.push(val); else arr.splice(pos, 1);
              answers[Q.id] = arr;
            }
          }
          clearError(Q.id);
          save();
          if (shouldAutoAdvance) {
            setTimeout(function () { next(); }, 300);
          }
        }
        opt.addEventListener("click", toggle);
        opt.addEventListener("keydown", function (e) {
          if (e.key === " " || e.key === "Enter") { e.preventDefault(); toggle(); }
        });
      });

      if (Q.kind === "multi_field" && Q.fields) {
        Q.fields.forEach(function (f) {
          var input = step.querySelector("#f-" + f.id);
          if (input) {
            input.addEventListener("input", function () {
              if (!answers[Q.id]) answers[Q.id] = {};
              answers[Q.id][f.id] = input.value;
              clearError(Q.id);
              save();
            });
            input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); next(); } });
          }
        });
      } else {
        var input = step.querySelector("#f-" + Q.id);
        if (input) {
          input.addEventListener("input", function () { answers[Q.id] = input.value; clearError(Q.id); save(); });
          input.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); next(); } });
        }
      }
      step.querySelector("[data-next]").addEventListener("click", next);
    });
  }

  function restoreStep(i) {
    var Q = STEPS[i];
    var step = shell.querySelector('[data-step="' + i + '"]');
    var val = answers[Q.id];
    if (!step || !Q.id) return;
    if (Q.kind === "radio") {
      step.querySelectorAll(".sf-edq-option").forEach(function (o) {
        var on = o.getAttribute("data-val") === val;
        o.classList.toggle("is-selected", on);
        o.setAttribute("aria-checked", on ? "true" : "false");
      });
    } else if (Q.kind === "checkbox") {
      var arr = Array.isArray(val) ? val : [];
      step.querySelectorAll(".sf-edq-option").forEach(function (o) {
        var on = arr.indexOf(o.getAttribute("data-val")) !== -1;
        o.classList.toggle("is-selected", on);
        o.setAttribute("aria-checked", on ? "true" : "false");
      });
    } else if (Q.kind === "multi_field" && Q.fields) {
      Q.fields.forEach(function (f) {
        var input = step.querySelector("#f-" + f.id);
        if (input && val && val[f.id] != null) input.value = val[f.id];
      });
    } else {
      var input = step.querySelector("#f-" + Q.id);
      if (input && val != null) input.value = val;
    }
  }

  function showError(id, msg) {
    var el = document.getElementById("err-" + id);
    if (el) { el.textContent = msg; el.classList.add("is-shown"); }
    var input = document.getElementById("f-" + id);
    if (input) input.classList.add("is-invalid");
  }
  function clearError(id) {
    var el = document.getElementById("err-" + id);
    if (el) el.classList.remove("is-shown");
    var input = document.getElementById("f-" + id);
    if (input) input.classList.remove("is-invalid");
  }

  function validate(i) {
    var Q = STEPS[i];
    if (!Q.id) return true; // Interstitials
    var val = answers[Q.id];
    if (Q.kind === "number") {
      var n = parseInt(val, 10);
      if (!val || isNaN(n)) { showError(Q.id, "Please enter your age."); return false; }
      if (n < (Q.min || 18)) { showError(Q.id, "You must be 18 or older."); return false; }
      if (n > (Q.max || 99)) { showError(Q.id, "Please enter a valid age."); return false; }
      return true;
    }
    if (Q.kind === "multi_field" && Q.fields) {
      var obj = val || {};
      for (var i = 0; i < Q.fields.length; i++) {
        var f = Q.fields[i];
        var fval = obj[f.id];
        if (f.type === "email" && (!fval || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fval))) {
          showError(Q.id, "Please enter a valid email address.");
          return false;
        }
        if (f.type === "text" && (!fval || !fval.trim())) {
          showError(Q.id, "Please enter your " + (f.label || "name").toLowerCase() + ".");
          return false;
        }
      }
      return true;
    }
    if (Q.kind === "text") {
      if (!val || !val.trim()) { showError(Q.id, "This field is required."); return false; }
      if (Q.pattern && !new RegExp(Q.pattern).test(val)) { showError(Q.id, "Please enter a valid value."); return false; }
      return true;
    }
    if (Q.kind === "email" && (!val || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val))) { showError(Q.id, "Please enter a valid email."); return false; }
    if (Q.kind === "tel" && ((val || "").replace(/\D/g, "").length < 10)) { showError(Q.id, "Please enter a valid mobile number."); return false; }
    if (Q.kind === "date" && !val) { showError(Q.id, "Please enter your date of birth."); return false; }
    if (Q.kind === "radio" && !val) { showError(Q.id, "Please choose an option."); return false; }
    if (Q.kind === "checkbox" && (!Array.isArray(val) || val.length === 0)) { showError(Q.id, "Please select at least one option."); return false; }
    return true;
  }

  function render() {
    shell.querySelectorAll(".sf-edq-step").forEach(function (s) { s.classList.remove("is-active"); });
    var step = shell.querySelector('[data-step="' + index + '"]');
    if (step) step.classList.add("is-active");
    if (counter) counter.textContent = "Step " + (index + 1) + " of " + total;
    if (fill) fill.style.width = Math.round(((index + 1) / total) * 100) + "%";
    if (backTop) backTop.disabled = index === 0;
    if (segments) {
      segments.querySelectorAll(".sf-edq-segment").forEach(function (seg, i) {
        seg.classList.toggle("is-active", i <= index);
        seg.classList.toggle("is-current", i === index);
      });
    }
    var firstInput = step && step.querySelector(".sf-edq-input");
    if (firstInput) { try { firstInput.focus(); } catch (e) {} }
    window.scrollTo(0, 0);
    answers.__step = index;
    save();
    if (window.lucide) lucide.createIcons();
  }

  function next() {
    if (!validate(index)) return;
    if (index < total - 1) { index++; render(); }
    else finish();
  }
  function back() {
    if (index > 0) { index--; render(); }
  }

  function finish() {
    answers.__completed = true;
    answers.__completedAt = new Date().toISOString();
    save();
    shell.style.display = "none";
    if (backTop) backTop.style.visibility = "hidden";
    if (fill) fill.style.width = "100%";
    if (counter) counter.textContent = "Complete";
    if (loading) loading.classList.add("is-active");
    if (window.lucide) lucide.createIcons();
    setTimeout(function () {
      var proof = document.getElementById("loadingProof");
      if (proof) proof.classList.add("is-shown");
    }, 600);
    setTimeout(function () { window.location.href = "/pages/ed-approval"; }, 2500);
  }

  buildSegments();
  buildSteps();
  STEPS.forEach(function (_, i) { restoreStep(i); });
  if (typeof answers.__step === "number" && answers.__step > 0 && answers.__step < total && !answers.__completed) index = answers.__step;
  if (backTop) backTop.addEventListener("click", back);
  render();
})();
